import * as React from "react";
import { AppNotification } from "../../utils/types/notifications";

export const NotificationContext = React.createContext<AppNotification[]>([]);
